import React from 'react'

import { ClientCreateModal } from 'core/client'

export const ModalContext = React.createContext()

export const ModalConsumer = ModalContext.Consumer

export function ModalProvider(props) {
  const [isClientCreateModalOpen, setClientCreateModalOpen] = React.useState(
    false
  )

  const openClientCreateModal = _ => setClientCreateModalOpen(true)
  const closeClientCreateModal = _ => setClientCreateModalOpen(false)

  return (
    <ModalContext.Provider
      value={{
        isClientCreateModalOpen,
        openClientCreateModal,
        closeClientCreateModal,
      }}
    >
      {props.children}

      <ClientCreateModal />
    </ModalContext.Provider>
  )
}

export default ModalContext
